import _objectSpread from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      form: {
        server_name: "",
        id: "",
        state: 1,
        date: ''
      },
      dialogShow: false,
      formMark: {},
      rules: {
        server_name: [{
          required: true,
          message: "请输入服务器名称",
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: "请选择状态",
          trigger: "blur"
        }],
        date: [{
          required: true,
          message: "请选择时间",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.formMark = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var k;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogShow = true; // Base64.decode(data.content)

                if (data) {
                  for (k in _this.formMark) {
                    _this.form[k] = data[k];
                  }

                  _this.form.date = [data.state_start_time, data.state_end_time];
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData(id) {
      this.form = _objectSpread({}, this.formMark);
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.form));
          data.state_start_time = data.date[0];
          data.state_end_time = data.date[1];
          var reqFn = _this2.form.id ? 'serverStateUpdate' : 'serverStateAdd';

          _this2.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};